import { InitFeatureParams } from '../types'

import { modalRoutes, routes } from './routes'

/**
 * 初始化测试卷
 *
 * @param param0 - 参数
 * @param param0.addRoutes - 添加路由
 */
export const initTestPaper = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(routes, modalRoutes)
}
